import { useSelector } from "react-redux";
import { FlexColumn, TextWrapper, TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";
import { StarSpan } from "../VehicleorAssetDetails/CamerasAndOtherAccessories";
import Select from "react-select";
import { getPendoId } from "../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

const AvailableTimeSlots = ({ availableSlots, apptDateAndTime, setApptTimeDateAndTime, slotsRef }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const { jobResponseData, jobDetails, isReschedule } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  const { jobDuration } = jobDetails || {};
  const isTablet = windowSize.width < DESKTOP;
  const isMobile = windowSize.width < TABLET;
  
  function getDuration(isReschedule, jobDuration, jobResponseData) {
    if (isReschedule) {
      return jobDuration ? parseFloat((jobDuration / 60).toFixed(1)) : 0;
    }
    return parseFloat((jobResponseData.appointmentLength).toFixed(1));
  }
  const duration = getDuration(isReschedule, jobDuration, jobResponseData);

  function getTimeSlotOptionBackgroundColor(state) {
    if (state.isFocused) {
      return "#0000000D";
    }
    if (state.isSelected) {
      return "var(--background-secondary, #F6F6F6)";
    }
    return "transparent";
  }

  return (
    <FlexColumn flex={1} marginTop={isTablet ? "1.5rem" : "2rem"} width="100%">
      <TextWrapper fontSize="1.25rem" fontWeight="700" lineHeight="1.5rem">
        Available time slots
      </TextWrapper>
      <TextWrapper marginTop="1rem !important" fontSize="0.875rem">
        <TextWrapperSpan fontWeight="700">Duration:</TextWrapperSpan>
        <TextWrapperSpan marginLeft="0.5rem">
          {duration} {`${duration > 1 ? "hours" : "hour"}`}
        </TextWrapperSpan>
      </TextWrapper>
      <TextWrapper fontSize="0.75rem" fontWeight="700" lineHeight="0.75rem" marginTop="1.5rem !important" marginBottom="0.5rem" ref={slotsRef}>
        Time slot <StarSpan disabled={!availableSlots.length}>*</StarSpan>
      </TextWrapper>
      <Select
        id={getPendoId("select-time-slot-dropdown")}
        // className="slots-dropdown-react"
        classNamePrefix="slots"
        options={availableSlots}
        getOptionLabel={(option) => option.slotOption}
        getOptionValue={(option) => option.slotOption}
        value={apptDateAndTime}
        onChange={(selectedOption) => {
          setApptTimeDateAndTime(selectedOption);
        }}
        placeholder={apptDateAndTime?.slotOption || "Select time slot"}
        isDisabled={!availableSlots.length}
        isSearchable={false}
        tabIndex={0}
        aria-label="Select a time slot"
        menuPlacement="auto"
        styles={{
          container: (base) => ({
            ...base,
            width: isMobile ? "100%" : "50%",
          }),
          control: (base, state) => ({
            ...base,
            width: "100%",
            height: "2.75rem",
            border: state.isFocused ? "2px solid var(--feedback-information, #006FC1)" : "1px solid #d8dada",
            borderRadius: "4px",
            fontSize: "0.875rem",
            fontFamily: '"neue-haas-grotesk-text"',
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            backgroundColor: state.isFocused ? "var(--background-secondary, #F6F6F6)" : "#fff",
            flexWrap: "nowrap",
            boxShadow: "none",
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "0.875rem",
            fontFamily: '"neue-haas-grotesk-text"',
            color: "#000",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            backgroundColor: "#fff",
            border: "1px solid #d8dada",
            fontSize: "0.875rem",
            fontFamily: '"neue-haas-grotesk-text"',
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#000",
            fontSize: "0.875rem",
            fontFamily: '"neue-haas-grotesk-text"',
          }),
          indicatorSeparator: () => ({
            display: "none",
          }),
          option: (base, state) => ({
            ...base,
            paddingTop: "14px", // Top padding
            paddingRight: "16px", // Right padding
            paddingBottom: "14px", // Bottom padding
            paddingLeft: "16px", // Left padding
            gap: "10px", // Gap between options
            fontSize: "0.875rem",
            fontWeight: 400,
            fontFamily: '"neue-haas-grotesk-text"',
            color: "#000",
            backgroundColor: getTimeSlotOptionBackgroundColor(state),
            cursor: "pointer",
            padding: "0.5rem",
            borderLeft: state.isSelected ? "4px solid #EE0000" : "4px solid transparent",
            "&:active": {
              backgroundColor: "#0000001F",
            },
          }),
        }}
      />
    </FlexColumn>
  );
};
AvailableTimeSlots.propTypes = {
  availableSlots: PropTypes.array.isRequired,
  apptDateAndTime: PropTypes.object,
  setApptTimeDateAndTime: PropTypes.func.isRequired,
  slotsRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ])
};

export default AvailableTimeSlots;